import { Badge } from '../../ui/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';
import type { DrawdownBatch } from '@/types/drawdown';
import { getDrawdownStatusBadgeClass } from './drawdownPreviewStatus';

interface DrawdownBatchNavigationProps {
  batches: DrawdownBatch[];
  currentBatchId: string;
  currentBatchIndex: number;
  onBatchChange: (batchId: string) => void;
}

export function DrawdownBatchNavigation({
  batches,
  currentBatchId,
  currentBatchIndex,
  onBatchChange,
}: DrawdownBatchNavigationProps) {
  const currentBatch = batches[currentBatchIndex];

  if (!currentBatch) {
    return null;
  }

  return (
    <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
      <div className="flex items-center gap-3">
        <span className="text-sm text-muted-foreground">Batch:</span>
        <Select value={currentBatchId} onValueChange={onBatchChange}>
          <SelectTrigger className="w-[200px] h-8">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {batches.map((batch) => (
              <SelectItem key={batch.id} value={batch.id}>
                Batch {batch.batch_number}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Badge className={getDrawdownStatusBadgeClass(currentBatch.status)}>
          {currentBatch.status}
        </Badge>
      </div>
    </div>
  );
}
